

import Vue from 'vue'
import router from './router'
import store from './store/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import App from './App'
import VueResource from 'vue-resource';
import 'font-awesome/css/font-awesome.min.css'
import parseMenu from '@/utils/MenuUtil'
import VueFilter from 'vue-filter'
import Vue2Filters from 'vue2-filters'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import FullCalendar from 'vue-full-calendar';

import "fullcalendar/dist/fullcalendar.min.css";

function randomn(n) {
let res = ''
for (; res.length < n; res += Math.random().toString(36).substr(2).toUpperCase()) {}
return res.substr(0, n)
}

Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.use(Vue2Filters);
Vue.use(VueFilter);
Vue.use(FullCalendar);

Vue.directive('dialogDrag', {
bind(el, binding, vnode, oldVnode) {
const dialogHeaderEl = el.querySelector('.el-dialog__header');
const dragDom = el.querySelector('.el-dialog');
dialogHeaderEl.style.cursor = 'move';

const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
dialogHeaderEl.onmousedown = (e) => {

const disX = e.clientX - dialogHeaderEl.offsetLeft;
const disY = e.clientY - dialogHeaderEl.offsetTop;

let styL, styT;

if(sty.left.includes('%')) {
styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
}else {
styL = +sty.left.replace(/\px/g, '');
styT = +sty.top.replace(/\px/g, '');
};
document.onmousemove = function (e) {

const l = e.clientX - disX;
const t = e.clientY - disY;

dragDom.style.left = `${l + styL}px`;
dragDom.style.top = `${t + styT}px`;


};
document.onmouseup = function (e) {
document.onmousemove = null;
document.onmouseup = null;
};
}
}
});

Vue.directive('dialogDragWidth', {
bind(el, binding, vnode, oldVnode) {
const dragDom = binding.value.$el.querySelector('.el-dialog');
el.onmousedown = (e) => {

const disX = e.clientX - el.offsetLeft;
document.onmousemove = function (e) {
e.preventDefault(); 

const l = e.clientX - disX;
dragDom.style.width = `${l}px`;
};
document.onmouseup = function (e) {
document.onmousemove = null;
document.onmouseup = null;
};
}
}
})

let staff = JSON.parse(window.sessionStorage.getItem('staff'))
if (staff){
console.log("Main refresh menus:",staff.menus);
if(staff.menus!=null){
let routes = []
parseMenu(routes,staff.menus);
router.addRoutes(routes);
router.options.routes.push(...routes);
}

store.commit("updateStaff",staff);
}

router.beforeEach((to, from, next) => {
let staff = JSON.parse(window.sessionStorage.getItem('staff'));
var ismobile = localStorage.getItem('ismobile');
if(ismobile == null){
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
ismobile = flag ? 1 : 0
}

if (ismobile == 0) {
if (!staff && to.path !== '/cal' && !staff && to.path !== '/start') {
next({ path: '/cal' })
}else {
next();
}
}

if (ismobile == 1) {
if( to.path !=='/cal'){
if (!staff && to.path !== '/cal' && !staff && to.path !== '/start') {
next({ path: '/cal' })
}else {
next();
}
}else{
next();
}
}
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js